<script>
  import { Pie } from 'vue-chartjs'
  export default {
    extends: Pie,
    props: ['data', 'options'],
    mounted () {
      this.renderChart(this.data, this.options)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Chart.vue?51e00908